// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-modal[data-v-6617ad0a]{border-radius:inherit;background:hsla(0,0%,100%,.9);position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;display:none}.loading-modal.big[data-v-6617ad0a]{width:100%;background:none}.loading-modal.open[data-v-6617ad0a]{display:block}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
